import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

/**
 * Vendor component.
 * @class
 */
@Component({
	selector: 'vendor',
	templateUrl: './vendor.component.html',
	styleUrls: ['./vendor.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VendorComponent {
	/**
	 * Input variable for providing 'is selected' value to component from parent.
	 */
	@Input() isSelected: boolean;
	/**
	 * Input variable for providing 'image' value to component from parent.
	 */
	@Input() image: string;
	/**
	 * Input variable for providing 'name' value to component from parent.
	 */
	@Input() name: string;

	/**
	 * Output variable for emitting 'click vendor' value from component to parent.
	 */
	@Output() clickVendor = new EventEmitter<void>();
}
